import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  createTicket,
  getTickets,
  updateTicket,
  deleteTicket,
  deleteTicketDocument,
} from "../../../api/tickets_api";

export const createTicketAction = createAsyncThunk(
  "tickets/createTicketAction",
  async (formData, { rejectWithValue }) => {
    try {
      const data = await createTicket(formData);

      return data;
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  },
);

export const getTicketsAction = createAsyncThunk(
  "tickets/getTicketsAction",
  async ({ userId }, { rejectWithValue }) => {
    try {
      const data = await getTickets(userId);
      return data; // this returns array of tickets or []
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const updateTicketAction = createAsyncThunk(
  "tickets/updateTicketAction",
  async ({ ticketId, formData }, { rejectWithValue }) => {
    try {
      const data = await updateTicket(ticketId, formData);
      return data;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const deleteTicketAction = createAsyncThunk(
  "tickets/deleteTicketAction",
  async (ticketId, { rejectWithValue }) => {
    try {
      await deleteTicket(ticketId);
      return ticketId; // reducer removes from list
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const deleteTicketDocumentAction = createAsyncThunk(
  "tickets/deleteTicketDocumentAction",
  async ({ TicketDocId, userId }, { rejectWithValue }) => {
    try {
      const response = await deleteTicketDocument({ TicketDocId, userId });
      return response; // reducer should refresh ticket details
    } catch (error) {
      return rejectWithValue(error.message || "Failed to delete document");
    }
  }
);